import React from 'react';
import PropTypes from 'prop-types';
import DialogContent from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogContent';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import DialogActions from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/DialogActions';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { isPresent } from 'utils/isPresent';
import ParentComponentSpinner from '../../../Common/MaterialUiExtended/Spinner/ParentComponentSpinner';
import ShippingAddressFormFields from './ShippingAddressFormFields';

const VEHICLE_GPS_TRACKING_SHIPPING_ADDRESS_FORM = 'vehicle_gps_tracking_shipping_address_form';

const validate = (values) => {
  const errors = {};

  errors.first_name = !values.first_name;
  errors.last_name = !values.last_name;
  errors.business_name = !values.business_name;
  errors.phone = !values.phone;
  errors.street_line1 = !values.street_line1;
  errors.city = !values.city;
  errors.state = (!values.state || !(values.state.length === 2));
  errors.country = !values.country;
  errors.postal_code = !values.postal_code;

  if (!values.agree_mojio_tc) {
    errors.agree_mojio_tc = 'Must agree with T&Cs';
  }

  return errors;
};

const ShippingAddressForm = ({
  submitting, handleSubmit, setErrorMessage, errorMessage, invalid, onCancel
}) => {
  const onSubmit = () => {
    setErrorMessage('');
    handleSubmit().then(() => {
      window.location.reload();
    }).catch((e) => {
      try {
        if(onCancel){
          setErrorMessage(`Failed to request return labels due to: ${e.response.data.errors[0]}`);
        } else {
          setErrorMessage(`Failed to order devices due to: ${e.response.data.errors[0]}`);
        }
      } catch (error) {
        if(onCancel){
          setErrorMessage('Failed to request return labels. Please try again later. Use the Blue Chat Bubble if the problem persists.');
        } else {
          setErrorMessage('Failed to order devices. Please try again later. Use the Blue Chat Bubble if the problem persists.');
        }
      }
    });
  };
  
  let formSubtitle = ""
  let submitText = ""
  if(onCancel){
    formSubtitle = <div>
    Force by Mojio will send your pre-paid return label to the email you have listed in your Force by Mojio account.
    <br/>
    <br/>
    Please confirm the details for your shipping label below:
    </div>
    submitText = "Request Label"
  }else{
    formSubtitle = "Send my GPS device to the following address"
    submitText = "Save shipping address"
  }

  return (
    <form id={VEHICLE_GPS_TRACKING_SHIPPING_ADDRESS_FORM} onSubmit={handleSubmit}>
      <DialogContent>
        <Typography variant="subtitle1">
          {formSubtitle}
        </Typography>
        <br />
        <ParentComponentSpinner showSpinner={submitting} />
        <ShippingAddressFormFields isAddressConfirmation={!isPresent(onCancel)} />
        <Typography color="error">
          {errorMessage}
        </Typography>

      </DialogContent>
      <DialogActions>
      {onCancel && <Button color="primary" variant="outlined" onClick={onCancel}>Cancel</Button>}
        <Button
          disabled={invalid || submitting}
          variant="contained"
          color="primary"
          onClick={onSubmit}
          type="submit"
        >
          {submitText}
        </Button>
      </DialogActions>
    </form>
  );
};

ShippingAddressForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  onCancel: PropTypes.func
};

const form = reduxForm({
  form: VEHICLE_GPS_TRACKING_SHIPPING_ADDRESS_FORM,
  validate,
})(ShippingAddressForm);

export default connect(
  (state) => ({
    initialValues: (state.appConfiguration || {}).shipping_address,
  }),
)(form);
